import React from 'react';

import ProductOfTheYear from './ProductOfTheYear';
import Quiz from './Quiz';

interface Props {
    contest: POYContest | QuizContest;
}

export const VoteSection = ({ contest }: Props) => {
    if (contest.type === 'quiz') return <Quiz contest={contest} />;
    return <ProductOfTheYear contest={contest} />;
};

export default VoteSection;
